
export const loadImage1 = true;
export const loadImage2 = false;
export const countProducts = true;